import validate from "/usr/src/app/content/n3-redirections-service-929a0c58-dca0-4673-8092-85269205ac2a/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-929a0c58-dca0-4673-8092-85269205ac2a/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}